module.exports = __webpack_public_path__ + "media/images/iconPaginatePrev-569433f4b4088e18a41aec0faf11e34f.png";